/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户id">
        <el-input size="small" v-model="formInline.payerUserid" placeholder="用户id"></el-input>
      </el-form-item>
      <el-form-item label="商家名称">
        <el-input size="small" v-model="formInline.mchName" placeholder="商家名称"></el-input>
      </el-form-item>
      <el-form-item label="订单id">
        <el-input size="small" v-model="formInline.orderId" placeholder="订单id"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="formInline.orderType" placeholder="请选择" size="medium">
          <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选泽日期：">
        <el-date-picker value-format='timestamp' v-model="formInline.value1" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="orderId" label="id" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mchName" label="餐厅名称" width="240" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="channelName" label="渠道名称" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="payerUserid" label="买单用户id" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="amount" label="订单金额" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="cash" label="实付金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-for="(item, index) in options" :key="index">
            <span v-if="item.value == scope.row.orderType">{{item.name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="goodsPrice" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.orderState == 1">订单完成</div>
          <div v-if="scope.row.orderState == 3 ">未核销</div>
          <div v-if="scope.row.orderState == 0 ">已退款</div>
          <div v-if="scope.row.orderState == 7 ">退款申请中</div>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="买单时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.payTime * 1000|timestampToTime}}</div>
        </template>
      </el-table-column>
      <!--  <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">预览</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    OrderList,
    orderType
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          payerUserid: '',
          mchName: '',
          orderId: '',
          value1: '',
          orderType: 0
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        options: [],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.orderType()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      orderType() {
        let pro = {}
        orderType(pro)
          .then(res => {

            this.options = res.data
            this.options.unshift({
              "name": "全部",
              "value": 0
            })
            console.log(this.options)
          })
      },
      // 获取公司列表
      getdata(parameter) {

        // 模拟数据开始

        // 模拟数据结束
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          "pageSize": parameter.limit,
          "payerUserid": parameter.payerUserid,
          "mchName": parameter.mchName,
          orderType: parameter.orderType,
          "orderId": parameter.orderId,
          "startDate": parameter.value1[0] / 1000,
          "endDate": parameter.value1[1] / 1000,
        }

        OrderList(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/pay/Order.vue